import React from 'react';

import { ResponsivePie } from '@nivo/pie';
import 'whatwg-fetch';
import { deleteEntity } from 'src/utils/entityApi';
import ModalConfirm from '../../components/modal/modalConfirm';
import { buildRequestStatistic } from 'src/utils/dashboardTools';
import Card from 'src/components/Card';
import { Link, Typography } from '@material-ui/core';
import withAuth from 'src/hoc/withAuth';

class DashletPieChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: undefined,
      dashletInfo: undefined,
      dashletParsed: false,
      isModalDeleteDashletOpen: false,
      textModal: {
        title: 'Suppression Dashlet',
        message: 'Vous allez supprimer le dashlet',
      },
    };

    this.openModalDeleteDashlet = this.openModalDeleteDashlet.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.update = this.update.bind(this);
  }

  refreshData(request) {
    this.props
      .authFetch(request, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          let myData = data['data'][this.state.dashletInfo.metadata.statisticSelected.graphQlQuery] || [];

          let total = myData.reduce((total, value) => {
            return total + parseInt(value['value'] || '0');
          }, 0);

          //We set the id for the legend labels
          for (let i = 0; i < myData.length; i++) {
            myData[i]['value'] = parseInt(myData[i]['value']);
            const percent = total ? (myData[i]['value'] * 100) / total : 0;
            myData[i]['id'] = myData[i]['label'] + ` - ${Math.round(percent)}%`;
          }

          this.setState({
            data: myData,
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch data: \n' + error);
        }.bind(this)
      );
  }

  componentDidMount() {
    let dashlet = this.props.dashletInfo;

    if (dashlet && !this.state.dashletParsed) {
      if (typeof dashlet.metadata === 'string')
        //Necessary when you switch dashboard and return
        dashlet.metadata = JSON.parse(dashlet.metadata);
      this.setState({
        dashletInfo: dashlet,
        dashletParsed: true,
      });
    }
    this.refreshData(buildRequestStatistic(dashlet));
  }

  openModalDeleteDashlet() {
    this.props.toggleBlackOut();
    this.setState({
      isModalDeleteDashletOpen: true,
    });
  }
  closeModal() {
    this.setState({
      isModalDeleteDashletOpen: false,
    });
    this.props.toggleBlackOut();
  }

  postResult(type, promise) {
    promise.then(
      function (result) {
        if (result.wentFine) {
          this.props.openToast(true, 'Succès supression ' + type);
          this.props.onDelete();
        } else {
          this.props.openToast(false, 'Erreur suppression ' + type + '. Veuillez réessayer');
        }
      }.bind(this)
    );
  }

  update() {
    this.props.onUpdate(this.state.dashletInfo);
  }

  render() {
    return (
      <Card style={{ display: 'block' }} className='dashlet'>
        <Typography variant='h6'>{this.state.dashletInfo ? this.state.dashletInfo.title : 'Chargement'}</Typography>
        <Link component='button' onClick={() => this.refreshData(buildRequestStatistic(this.state.dashletInfo))}>
          Rafraîchir
        </Link>
        {` - `}
        <Link component='button' onClick={this.update}>
          Editer
        </Link>

        {this.state.dashletInfo && (
          <button
            onClick={this.openModalDeleteDashlet}
            type='button'
            className='close dashlet-close'
            aria-label='Close'
          >
            <span aria-hidden='true'>&times;</span>
          </button>
        )}
        <div className='dashlet-content'>
          {this.state.data && (
            <ResponsivePie
              data={this.state.data}
              margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
              innerRadius={0.5}
              padAngle={0.7}
              cornerRadius={3}
              colors={{ scheme: 'nivo' }}
              borderWidth={1}
              borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
              radialLabelsSkipAngle={10}
              radialLabelsTextXOffset={6}
              radialLabelsTextColor='#333333'
              radialLabelsLinkOffset={0}
              radialLabelsLinkDiagonalLength={16}
              radialLabelsLinkHorizontalLength={24}
              radialLabelsLinkStrokeWidth={1}
              radialLabelsLinkColor={{ from: 'color' }}
              slicesLabelsSkipAngle={10}
              slicesLabelsTextColor='#333333'
              animate={true}
              motionStiffness={90}
              motionDamping={15}
              legends={[
                {
                  anchor: 'bottom',
                  direction: 'row',
                  translateY: 56,
                  itemWidth: 150,
                  itemHeight: 18,
                  itemTextColor: '#999',
                  symbolSize: 18,
                  symbolShape: 'circle',
                  effects: [
                    {
                      on: 'hover',
                      style: {
                        itemTextColor: '#000',
                      },
                    },
                  ],
                },
              ]}
            />
          )}
        </div>

        <ModalConfirm
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalDeleteDashletOpen}
          onSubmit={() =>
            this.postResult('dashlet', deleteEntity(this.props.authFetch, 'dashlet', this.state.dashletInfo.id))
          }
          onCancel={this.closeModal}
          onClose={this.closeModal}
        />
      </Card>
    );
  }
}

export default withAuth(DashletPieChart);
